var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger-icon",class:_vm.menuState},[_c('div',{staticClass:"dash upper"}),_c('div',{staticClass:"dash middle"}),_c('div',{staticClass:"dash lower"})])}
var staticRenderFns = []

export { render, staticRenderFns }